import { render, staticRenderFns } from "./tv_show.vue?vue&type=template&id=0c1b231c&"
import script from "./tv_show.vue?vue&type=script&lang=js&"
export * from "./tv_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports